exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".defaultCustomSearchBox{\n    font-size: 25px;\n    color: #fff;\n    padding-left:80px;\n}\n.defaultCustomSearchBox::-webkit-input-placeholder{\n    font-size: 25px;\n    color: #fff;\n}\n.defaultCustomSearchBox::-ms-input-placeholder{\n    font-size: 25px;\n    color: #fff;\n}\n.defaultCustomSearchBox::placeholder{\n    font-size: 25px;\n    color: #fff;\n}", ""]);

// exports
